import createAction from './create-action';
import ApiService from '../../services/api-service';
import { Dispatch } from 'redux';

/**
 * ACTION TYPES
 */
export const SLIDESHOW_GET = 'slideshow:get';

/**
 * THUNKS
 */

export const resetSlideshow = () => (dispatch: Dispatch) => dispatch(createAction(`${SLIDESHOW_GET}:reset`));

export const getSlideshow = (slideshowId: string | number) => (dispatch: Dispatch) => {
  return dispatch(
    createAction(SLIDESHOW_GET, ApiService.getSlideshow(slideshowId), {
      __PARSABLE__: true,
    })
  );
};
